import React from 'react';
import {UnexpectedErrorMessage} from './Messages/UnexpectedErrorMessage.js';

export const ContextError = ({refresh = true}) => {

    return <UnexpectedErrorMessage refresh={refresh}/>;
};